export var firebaseConfig = {
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    apiKey: "AIzaSyCK8bBvUZTVjvHqUrKgRoLwTFSR43F5frQ",
    authDomain: "socialsportx.firebaseapp.com",
    databaseURL: "https://socialsportx-default-rtdb.firebaseio.com",
    projectId: "socialsportx",
    storageBucket: "socialsportx.appspot.com",
    messagingSenderId: "744985134063",
    appId: "1:744985134063:web:4631b3849ed2e0b619ac1a",
    measurementId: "G-F2W9C3H4B4"
};
